/* eslint-disable array-callback-return */
/* eslint-disable no-async-promise-executor */
/* eslint-disable prefer-const */
import CryptoJS from 'crypto-js';

import Def from '@/config/Def';

const HttpClient = {
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  },

  decodeStr(str) {
    if (!str || str === '') {
      return '{}';
    }
    let { cryptoObj } = global;
    let decrypted = CryptoJS.AES.decrypt(str, cryptoObj.key, cryptoObj.option);
    decrypted = CryptoJS.enc.Utf8.stringify(decrypted);
    return decrypted;
  },

  encodeStr(obj) {
    let { cryptoObj } = global;
    let str = JSON.stringify(obj);
    let encrypted = CryptoJS.AES.encrypt(str, cryptoObj.key, cryptoObj.option);
    return encrypted.toString();
  },

  async getFile(url) {
    const json = await fetch(url, {
      method: 'GET',
    });
    return await json.text();
  },

  async getRequest(url = '', data = {}, redirect = false, retryCount = 0, isAlert = true, method = 'POST') {
    // 添加数据
    if (!data) {
      data = {};
    }
    const oldData = { ...data };
    return new Promise(async resolve => {
      try {
        let json = await fetch(url, {
          method,
          headers: {
            'Content-Type': 'application/json',
            'Verify-Token': window.localStorage.getItem('verify_token') || '',
          },
          body: method.toUpperCase() !== 'GET' ? JSON.stringify(data) : undefined,
        });
        if (json.status !== 200) {
          // 状态错误
          const bodyText = await json.text();
          resolve({
            code: json.status,
            jserr: json.statusText,
          });
        } else {
          let jsonstr = await json.json();
          if (jsonstr.error === 1000) {
            // token 错误
            if (redirect) {
              await global.storage.remove({
                key: 'token',
              });
              // token 错误，并且需要跳转
              resolve({
                code: '2-023',
                jserr: `Wallet session expired, please log in again.`,
              });
            }
          }
          if (jsonstr?.code && jsonstr.code.toString().indexOf('2-023') !== -1) {
            // token 错误
            // token 错误，并且需要跳转
            resolve({
              code: '2-023',
              jserr: `Wallet session expired, please log in again.`,
            });
          }

          let res = jsonstr;
          if (jsonstr.data && jsonstr.data.enc && jsonstr.data.enc !== '') {
            res = this.decodeStr(jsonstr.data.enc);
            res = JSON.parse(res);
            jsonstr.data = res;
          }
          resolve(jsonstr);
        }
      } catch (err) {
        if (!isAlert) {
          resolve({
            error: -1,
            jserr: `${err}`,
          });
          return;
        }
        if (retryCount <= Def.HTTP_RETRY_TIMES) {
          await this.sleep(800);
          resolve(await this.getRequest(url, oldData, redirect, retryCount + 1, isAlert, method));
        }
      }
    });
  },

  async post(uri, data = {}, redirect = true, isAlert = true) {
    // 设置正在请求的map
    let apiURI = uri;
    if (!uri.startsWith('http')) {
      // 当没有直接指定服务地址时认为是旧服务，新服务可能会使各接口的地址不一致，所以直接在接口上指定了
      apiURI = `${process.env.REACT_APP_GAME_API}${uri}`;
    }
    const httpResp = await this.getRequest(apiURI, data, redirect, 0, isAlert);
    // 新服务的code为200表示成功
    // 清除正在请求的uri
    return httpResp;
  },

  async get(uri, data = {}, redirect = true, isAlert = true) {
    // 设置正在请求的map
    let apiURI = uri;
    if (!uri.startsWith('http')) {
      // 当没有直接指定服务地址时认为是旧服务，新服务可能会使各接口的地址不一致，所以直接在接口上指定了
      apiURI = `${process.env.REACT_APP_GAME_API}${uri}`;
    }
    Object.keys(data).map((item, index) => {
      if (index == 0) {
        apiURI = `${apiURI}?${item}=${data[item]}`;
      } else {
        apiURI = `${apiURI}&${item}=${data[item]}`;
      }
    });
    const httpResp = await this.getRequest(apiURI, data, redirect, 0, isAlert, 'GET');
    return httpResp;
  },
};

export default HttpClient;
